import { AfterViewInit, Component, Input, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { isJobReadyCandidate, visibleJobStatus } from '@classes/job-ready';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

@Component({
  selector: 'app-patient-order-table',
  templateUrl: './patient-order-table.component.html',
  styleUrls: ['./patient-order-table.component.css'],
  animations: [
    trigger('detailExpand', [
      state(
        'collapsed',
        style({ height: '0px', minHeight: '0', visibility: 'hidden' })
      ),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')
      ),
    ]),
  ],
})
export class PatientOrderTableComponent implements AfterViewInit {
  @Input() variant: 'orders' | 'inquiries' = 'orders';
  @Input() host: any;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private router: Router) {}

  showSuperbillActions(order: any): boolean {
    if (!order?.superbillRequested) {
      return false;
    }
    const due = Number(order?.financials?.balanceDue);
    return order?.status === 'DISPENSED' || (!isNaN(due) && due <= 0.009);
  }

  ngAfterViewInit(): void {
    if (this.host) {
      this.host.sort = this.sort;
    }
  }

  get isOrders(): boolean {
    return this.variant === 'orders';
  }

  get isInquiries(): boolean {
    return this.variant === 'inquiries';
  }

  isJobReadyRow(order: any): boolean {
    return isJobReadyCandidate(order);
  }

  visibleStatus(order: any): string {
    return visibleJobStatus(order) || String(order?.status || '');
  }

  addRow($event: Event): void {
    if (this.isInquiries) {
      this.host.addOrder($event, 'INQUIRY');
      return;
    }
    this.host.addOrder($event);
  }

  onRowClick($event: Event, row: FormGroup, index: number): void {
    const target = $event.target as HTMLElement | null;
    if (
      target?.closest(
        'input, textarea, button, a, mat-form-field, .mat-mdc-form-field, .action-controls, .mat-mdc-checkbox, .mat-mdc-menu-trigger'
      )
    ) {
      return;
    }
    if (this.isOrders) {
      this.host.openOrderScreen(row);
      return;
    }
    this.host.toggleExpanded($event, row, index);
  }

  openOrderEdit($event: Event, order: FormGroup): void {
    $event.preventDefault();
    $event.stopPropagation();
    const patientId =
      this.host.patient?._id ||
      order.value?.patient?._id ||
      order.value?.patient ||
      null;
    const orderId = order.value?._id;
    if (!patientId || !orderId) {
      return;
    }
    this.router.navigate(['/admin/patient', patientId], {
      queryParams: { order: orderId },
      queryParamsHandling: 'merge',
    });
  }

  expandedColumns(order: FormGroup): string[] {
    if (this.isOrders) {
      return this.host.getDisplayedColumns2(order);
    }
    return this.host.displayedColumns2;
  }
}
